import React from 'react';

import { locale } from '@trqk/utils';

/**
 * A toast message shown when the backend detects that a statement is a duplicate.
 */
export const DuplicateStatement = (): JSX.Element => (
        <div style={{ width: 410 }} className="px-2">
            <div className="font-bold text-highlight-orange tracking-wider mb-1">
                {
                    locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE
                        .DUPLICATE_STATEMENT.TITLE
                }
            </div>
            <div className="my-2">
                {
                    locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE
                        .DUPLICATE_STATEMENT.PART_1
                }
            </div>
            <div className="my-2">
                {
                    locale.enUS.INGESTION.TOASTS.STATEMENT_FAILURE
                        .DUPLICATE_STATEMENT.PART_2
                }
            </div>
        </div>
    );
